import {
  ActionIcon,
  TextInput,
  Tooltip,
} from '@mantine/core'
import { useClipboard } from '@mantine/hooks'
import {
  IconCheck,
  IconCopy,
} from '@tabler/icons-react'
import React from 'react'

import { TooltipInfo } from '@components/ui/form/dirty-field'

export interface ReadOnlyFieldProps {
  label: string
  value?: string
  enableClipboard?: boolean
  tooltip?: string | React.ReactNode
}

export const ReadOnlyField = ({
                                label,
                                value,
                                enableClipboard,
                                tooltip = false,
                              }: ReadOnlyFieldProps) => {
  const clipboard = useClipboard({
    timeout: 2000,
  })

  const displayValue = value || '-'

  const renderRightSection =
    enableClipboard ? (
      <Tooltip
        label={
          clipboard.copied
            ? 'Copied!'
            : 'Copy'
        }
        withArrow
        position="top"
      >
        <ActionIcon
          variant="subtle"
          color={
            clipboard.copied
              ? 'teal'
              : 'gray'
          }
          onClick={() =>
            value && clipboard.copy(value)
          }
          disabled={!value}
          aria-label="Copy to clipboard"
        >
          {clipboard.copied ? (
            <IconCheck size={16} />
          ) : (
            <IconCopy size={16} />
          )}
        </ActionIcon>
      </Tooltip>
    ) : undefined

  return (
    <TextInput
      label={
        <>
          {label}
          {tooltip ? (
            <TooltipInfo
              tooltip={tooltip}
            />
          ) : null}
        </>
      }
      value={displayValue}
      readOnly
      variant="filled"
      rightSection={renderRightSection}
      styles={{
        input: {
          backgroundColor:
            'var(--mantine-color-gray-2)',
          border:
            '1px solid var(--mantine-color-gray-3)',
          cursor: 'default',
        },
      }}
    />
  )
}